import { useEffect } from 'react';

export const useLockBodyScroll = (lock: boolean) => {
	useEffect(() => {
		if (!lock) return;

		// Guarda el desplazamiento actual
		const scrollY = window.scrollY;
		// Fija el body en su posición
		Object.assign(document.body.style, {
			position: 'fixed',
			top: `-${scrollY}px`,
			left: '0',
			right: '0',
			overflow: 'hidden',
			width: '100%',
		});

		return () => {
			// Restaura el body
			const y = document.body.style.top;
			Object.assign(document.body.style, {
				position: '',
				top: '',
				left: '',
				right: '',
				overflow: '',
				width: '',
			});
			// Devuelve al usuario donde estaba
			window.scrollTo(0, parseInt(y || '0') * -1);
		};
	}, [lock]);
};
